// extracted by mini-css-extract-plugin
export default {"progressContainer":"ChallengeProgressBar_progressContainer__uOpUm","questionLabel":"ChallengeProgressBar_questionLabel__1cOsn"};